import { Grid } from '@material-ui/core';
import {
  NotificationListTitle,
  NotificationListWrapper,
} from 'components/Notifications/styles';
import {
  Notification,
  NotificationListProps,
} from 'components/Notifications/types';
import moment from 'moment';
import React from 'react';
import { useIntl } from 'react-intl';
import NotificationItem from '../Item';

const API_RESPONSE_MONTH_FORMAT = 'MM/YYYY';

const NotificationList = ({ title, items }: NotificationListProps) => {
  const { formatDate } = useIntl();
  return (
    <NotificationListWrapper container direction="column" wrap="nowrap">
      <Grid item>
        <NotificationListTitle weight="400">
          {formatDate(moment(title, API_RESPONSE_MONTH_FORMAT).toDate(), {
            year: 'numeric',
            month: 'long',
          })}
        </NotificationListTitle>
      </Grid>
      <Grid item>
        <Grid container direction="column" justify="center">
          {items.map((item: Notification) => {
            return <NotificationItem key={item.id} {...item} />;
          })}
        </Grid>
      </Grid>
    </NotificationListWrapper>
  );
};

export default NotificationList;
